import { IncidentType, SearchAndRescueUnit, VtsCorrespondent, VtsRemarkTemplate } from "@/models"
import { SARLogHttpService } from "@/services/httpService"

export class DataService extends SARLogHttpService {
	constructor() {
		super("/api/data")
	}

	async getIncidentTypes(): Promise<IncidentType[]> {
		return await this.returning(IncidentType.array()).get("incident-types")
	}

	async getSearchAndRescueUnits(): Promise<SearchAndRescueUnit[]> {
		return await this.returning(SearchAndRescueUnit.array()).get("search-and-rescue-units")
	}

	async getVtsCorrespondents(): Promise<VtsCorrespondent[]> {
		return await this.returning(VtsCorrespondent.array()).get("vts-correspondents")
	}

	async getVtsRemarkTemplates(): Promise<VtsRemarkTemplate[]> {
		return await this.returning(VtsRemarkTemplate.array()).get("vts-remark-templates")
	}
}
